module.exports = __webpack_public_path__ + "img/keycap-digit-eight.3c33dace.png";